import PropTypes from 'prop-types';

export const PeriodPropTypes = PropTypes.shape({
  name: PropTypes.string.isRequired,
  taxYear: PropTypes.string.isRequired,
});

export const PeriodsPropTypes = PropTypes.shape({
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
});
